import Skeleton from "react-loading-skeleton";
import Prestation from "../../components/prestation";

const Prestations = ({ prestations, status, buttonAction }) => {
  // Loading state handling
  // console.log({prestations})
  if (status === "loading") {
    return (
      <div className="etablissement-services mt-24">
        <div className="single row">
          <div className="services-col col-md-8">
            <h3 className="grey500">
              <Skeleton width={200} />
            </h3>
            <div className="service-cards">
              {[...Array(5)].map((_, index) => (
                <div key={index} className="service-card">
                  <Skeleton width={150} />
                </div>
              ))}
            </div>
          </div>
          <div className="hours-col col-md-4">
            <Skeleton width="100%" height={300} />
            <Skeleton width="100%" height={300} style={{ marginTop: "8px" }} />
          </div>
        </div>
      </div>
    );
  }

  if (!prestations || prestations.length === 0) {
    return <div>No prestations available.</div>;
  }

  return (
    <div className="etablissement-services rdv mt-24">
      <div className="single row">
        <div className="services-col">
          <h3 className="grey500">Prestations</h3>

          {prestations.length > 0 ? (
            prestations
            .map((prestation) => (
              <Prestation
                key={prestation.id}
                prestation={prestation}
                selected={prestation.selected}
                buttonAction={() => 
                  buttonAction(
                    prestation, 
                    prestation.selected ? 'delete' : 'add'
                  )
                }
                classNameBtn="link-blue"
                buttonName={
                  prestation.selected ? (
                    <img src="/images/trash.svg" alt="Supprimer" />
                  ) : (
                    <>
                      Ajouter <img src="/images/plus-01.svg" className="ml-8" alt="Ajouter"/>
                    </>
                  )
                }
              />
            ))
          ) : (
            <p>Aucune prestation sélectionnée</p>
          )}
        </div>
        <div className="hours-col col-md-4"></div>
      </div>
    </div>
  );
};

export default Prestations;